import { render } from "./DocsSpanish.vue?vue&type=template&id=a1b40456"
import script from "./DocsSpanish.vue?vue&type=script&lang=js"
export * from "./DocsSpanish.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__